import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { DataGridConfig } from './data-grid-config';

@Component({
  selector: 'db-data-grid',
  templateUrl: './data-grid.component.html',
  styleUrls: ['./data-grid.component.scss']
})
export class DataGridComponent implements OnInit {
  @Input() dataGridConfig: DataGridConfig;
  @Input() rowData;

  @Output() selectedRows: EventEmitter<any> = new EventEmitter();
  @Output() selectedRowData: EventEmitter<Object> = new EventEmitter();
  @Output() cellEditingStopped: EventEmitter<Object> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    if (!this.dataGridConfig.gridOptions) {
      this.dataGridConfig.gridOptions = {
        enableFilter: true,
        enableSorting: true,
        headerHeight: this.getHeaderAndRowHeight(),
        pagination: true,
        paginationPageSize: 10,
        rowHeight: this.getHeaderAndRowHeight(),
        suppressMovableColumns: true
      };
    }

    this.dataGridConfig.domLayout = 'autoHeight';
  }

  getHeaderAndRowHeight() {
    if (this.dataGridConfig.gridCompact) {
      return 35;
    } else {
      return 48;
    }
  }

  gridReady(params) {
    // TODO: Fix - size columns not working when loaded in tabs.
    // https://github.com/ag-grid/ag-grid/issues/997
    params.api.sizeColumnsToFit();

    window.addEventListener('resize', function () {
      setTimeout(function () {
        params.api.sizeColumnsToFit();
      });
    });

    if (!this.dataGridConfig.gridStriped) {
      this.dataGridConfig.gridStriped = true;
    }
  }

  onRowSelected(event) {
    this.selectedRowData.emit(event.node.data);
  }

  onSelectionChanged(event) {
    this.selectedRows.emit(event.api.getSelectedRows());
  }

  onCellEditingStopped(event) {
    this.cellEditingStopped.emit(event.data);
  }

}
